
<template>
  <div class="likes">
    <b-list-group>
      <b-list-group-item v-for="like in likes"  v-bind:key="like.id">
        <Like :like-title="like.title.rendered" :liked-postid="like.idea_post_id[0]"></Like>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import Like from '@/components/Like'
export default {
  components: {
    Like
  },
  props: [
    'likes'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/Likes.vue